/** @format */

import { Button, Loading, Modal, TextArea } from "carbon-components-react";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import UIShell from "../../components/UIShell";
import UIShellPagination from "../../components/UIShellPagination";
import PageHelper from "../../helpers/Pagehelper";
import {
  fetchPolicies,
  updatePolicy,
} from "../../redux/actions/policiesAction";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function PoliciesPage({ isLoading }) {
  const history = useHistory();
  const dispatch = useDispatch();

  const [isLoadingData, setIsLoadingData] = useState(true);

  const headers = [
    {
      key: "type",
      header: "Title",
    },
    {
      key: "content",
      header: "Description",
    },
  ];

  const [paginationContent, setPaginationContent] = useState({
    page: 0,
    limit: 20,
    total: 0,
    totalItems: 0,
    rows: [],
  });

  const [modalContent, setModalContent] = useState({
    modalHeading: "",
    isOpen: false,
    policyId: undefined,
    policyName: undefined,
    policyContent: undefined,
  });

  const mapToColumn = (row) => {
    return {
      _id: row._id,
      type: row.type,
      content: row.content,
    };
  };

  const updatePolicyDetail = () => {
    dispatch(
      updatePolicy(
        {
          policyId: modalContent.policyId,
          policyName: modalContent.policyName,
          policyContent: content,
        },
        () => {
          // reset modal content
          setContent("");
          setModalContent({
            modalHeading: "",
            isOpen: false,
            policyId: undefined,
            policyName: undefined,
            policyContent: undefined,
          });

          fetch({ query: "", page: 0, limit: paginationContent.limit });
        }
      )
    );
  };

  const viewCategoryDetail = (_data) => {
    const policyId = _data[0].id.split(":")[0];
    const policyName = _data[0].value;
    const policyContent = _data[1].value;

    setContent(policyContent);

    setModalContent((v) => ({
      isOpen: true,
      modalHeading: `${policyName}`,
      policyId,
      policyName,
      policyContent,
    }));
  };

  const fetch = ({ total, limit }) => {
    setIsLoadingData(true);
    dispatch(
      fetchPolicies(({ filteredData }) => {
        setPaginationContent((v) => ({
          ...v,
          totalItems: PageHelper.getTotalItems(total, limit),
          rows: filteredData.map(mapToColumn),
        }));
        setIsLoadingData(false);
      })
    );
  };

  useEffect(() => {
    fetch(paginationContent);
  }, []);

  const [content, setContent] = useState("");

  return (
    <UIShell
      breadcrumbs={[
        { name: "Home", link: "/" },
        { name: "Policies and Terms" },
      ]}
    >
      {isLoadingData && <Loading />}
      <UIShellPagination
        dataTableList={paginationContent.rows}
        headers={headers}
        createForm={() => history.push("/policies/form")}
        viewDetail={viewCategoryDetail}
        totalItems={paginationContent.totalItems}
        withExpander={true}
        withCreatable={false}
        withPagination={false}
        withDelete={false}
        isHtmlContent
      />

      <Modal
        modalHeading={modalContent.modalHeading}
        modalLabel="Policies details"
        primaryButtonText="Update"
        primaryButtonDisabled={isLoading}
        secondaryButtonText="Cancel"
        open={modalContent.isOpen}
        onRequestSubmit={() => updatePolicyDetail()}
        onRequestClose={() => setModalContent((v) => ({ ...v, isOpen: false }))}
      >
        <ReactQuill theme="snow" value={content} onChange={setContent} />
      </Modal>
    </UIShell>
  );
}

const mapStateToProps = (state) => {
  return {
    dataTableList: state.policiesReducer.dataTableList,
    isLoading: state.uxReducer.isLoading,
  };
};

export default connect(mapStateToProps)(PoliciesPage);
